import { render, staticRenderFns } from "./ModalTokuDomiciliacion.vue?vue&type=template&id=e5771b5c&scoped=true"
import script from "./ModalTokuDomiciliacion.vue?vue&type=script&lang=js"
export * from "./ModalTokuDomiciliacion.vue?vue&type=script&lang=js"
import style0 from "./ModalTokuDomiciliacion.vue?vue&type=style&index=0&id=e5771b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5771b5c",
  null
  
)

export default component.exports